/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PowerMeterMetadataDto
 */
export interface PowerMeterMetadataDto {
    /**
     *
     * @type {string}
     * @memberof PowerMeterMetadataDto
     */
    switchboardId?: string;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardLoadLimitA?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardCapacityA?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardMaxCapacityL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardMaxCapacityL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardMaxCapacityL3Amps?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardBufferL1?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardBufferL2?: number;
    /**
     *
     * @type {number}
     * @memberof PowerMeterMetadataDto
     */
    switchboardBufferL3?: number;
    /**
     *
     * @type {string}
     * @memberof PowerMeterMetadataDto
     */
    metadata?: string;
}

/**
 * Check if a given object implements the PowerMeterMetadataDto interface.
 */
export function instanceOfPowerMeterMetadataDto(
    value: object,
): value is PowerMeterMetadataDto {
    return true;
}

export function PowerMeterMetadataDtoFromJSON(
    json: any,
): PowerMeterMetadataDto {
    return PowerMeterMetadataDtoFromJSONTyped(json, false);
}

export function PowerMeterMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PowerMeterMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        switchboardId:
            json["switchboardId"] == null ? undefined : json["switchboardId"],
        switchboardLoadLimitA:
            json["switchboardLoadLimitA"] == null
                ? undefined
                : json["switchboardLoadLimitA"],
        switchboardCapacityA:
            json["switchboardCapacityA"] == null
                ? undefined
                : json["switchboardCapacityA"],
        switchboardMaxCapacityL1Amps:
            json["switchboardMaxCapacityL1Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL1Amps"],
        switchboardMaxCapacityL2Amps:
            json["switchboardMaxCapacityL2Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL2Amps"],
        switchboardMaxCapacityL3Amps:
            json["switchboardMaxCapacityL3Amps"] == null
                ? undefined
                : json["switchboardMaxCapacityL3Amps"],
        switchboardBufferL1:
            json["switchboardBufferL1"] == null
                ? undefined
                : json["switchboardBufferL1"],
        switchboardBufferL2:
            json["switchboardBufferL2"] == null
                ? undefined
                : json["switchboardBufferL2"],
        switchboardBufferL3:
            json["switchboardBufferL3"] == null
                ? undefined
                : json["switchboardBufferL3"],
        metadata: json["metadata"] == null ? undefined : json["metadata"],
    };
}

export function PowerMeterMetadataDtoToJSON(
    value?: PowerMeterMetadataDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        switchboardId: value["switchboardId"],
        switchboardLoadLimitA: value["switchboardLoadLimitA"],
        switchboardCapacityA: value["switchboardCapacityA"],
        switchboardMaxCapacityL1Amps: value["switchboardMaxCapacityL1Amps"],
        switchboardMaxCapacityL2Amps: value["switchboardMaxCapacityL2Amps"],
        switchboardMaxCapacityL3Amps: value["switchboardMaxCapacityL3Amps"],
        switchboardBufferL1: value["switchboardBufferL1"],
        switchboardBufferL2: value["switchboardBufferL2"],
        switchboardBufferL3: value["switchboardBufferL3"],
        metadata: value["metadata"],
    };
}
